/* Meekijken voor Frontrun (/live-bezoekers → Meekijken): de pagina zoals de
   bezoeker hem ziet, met muis, kliks en scrollen, live naar het dashboard.
   Opname met rrweb (MIT), van jsDelivr met een vaste versie; het dashboard
   speelt hem af met rrweb's Replayer van dezelfde versie (2.1.6). Het
   eventformaat hoort bij de versie: verander ze alleen samen.

   WANNEER WEL (UK GDPR/PECR): alleen met analytics-toestemming uit Shopify's
   eigen cookiebanner, gecontroleerd bij de start EN bij elke batch; alleen bij
   een UK-tijdzone; nooit op /account, /checkouts of /orders (de checkout laadt
   dit thema sowieso niet). Dezelfde poort als brand-gedrag.js.

   WAT ER NIET MEEGAAT: geen enkele ingetypte waarde (maskAllInputs), geen
   tekst in account-, klant- of zoekgebieden (maskTextSelector), en geen
   iframes, betaalknoppen of formulieren naar /contact (nieuwsbrief en
   contact: daar typt iemand zijn mailadres) — die worden een leeg vlak.

   WIE: Shopify's uniqToken, dezelfde id als de pixel en brand-gedrag.js. De
   server maakt er meteen de gezouten hash `wie` van en geeft die terug; die
   gaat als tag frontrun_wie naar Clarity, zodat het dashboard per bezoeker
   naar Clarity kan wijzen zonder het ruwe id te tonen.

   VERKEER: Broadcast wijzigt de DOM aan één stuk (video, carrousels,
   animaties bij het scrollen), dus muisbewegingen elke 50 ms, scrollen elke
   150 ms, invoer alleen de laatste stand. Elke 2 s een batch van hoogstens
   ~200 kB (ingepakt met CompressionStream als de browser dat kan), elke 60 s
   een nieuwe momentopname zodat wie halverwege gaat kijken kan beginnen. */
(function () {
  var DOEL = 'https://frontrun.tristanzoethout.nl/bezoek/opname';
  var BIB = 'https://cdn.jsdelivr.net/npm/@rrweb/record@2.1.6/umd/record.min.js';
  var BATCH_MAX = 200000;

  /* REGELS:BEGIN — pure functies; test-web/test-opname-thema.mjs in de
     Frontrun-repo knipt dit blok eruit en toetst het. */
  var UK = /^Europe\/(London|Jersey|Guernsey|Isle_of_Man)$/;
  // Met of zonder taalvoorvoegsel (/en-us/account): Shopify Markets zet dat ervoor.
  var NOOIT = /^(\/[a-z]{2}(-[a-z]{2})?)?\/(account|checkouts?|orders)(\/|$)/i;
  function magOpnemen(tz, pad, toestemming) {
    return toestemming === true && UK.test(String(tz || '')) && !NOOIT.test(String(pad || ''));
  }
  /* Events in batches van hoogstens `max` tekens JSON. Eén event dat in zijn
     eentje groter is (een momentopname) gaat alleen; de server neemt tot
     300 kB ingepakt, en een momentopname pakt een factor 5-10 in. Na een Meta
     (type 4) wordt nooit geknipt: de afspeler heeft de schermmaat uit de Meta
     nodig bij de momentopname die erop volgt (gemeten 10-10-2026: los
     verstuurd bleef het beeld leeg). */
  function inBatches(events, max) {
    var uit = [], nu = [], maat = 0;
    for (var i = 0; i < events.length; i++) {
      var n = JSON.stringify(events[i]).length + 1;
      if (nu.length && maat + n > max && nu[nu.length - 1].type !== 4) { uit.push(nu); nu = []; maat = 0; }
      nu.push(events[i]); maat += n;
    }
    if (nu.length) uit.push(nu);
    return uit;
  }
  /* REGELS:END */

  var tz = '';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
  if (!UK.test(tz) || !window.fetch || !window.JSON) return;

  function toestemming() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed()); } catch (e) { return false; }
  }
  function mag() { return magOpnemen(tz, location.pathname, toestemming()); }
  function wie() {
    try { return window.ShopifyAnalytics.lib.user().traits().uniqToken || ''; } catch (e) { return ''; }
  }
  try {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
  } catch (e) {}

  var paginaId = '', seq = 0, buffer = [], stop = null, laden = false, clarityTag = '', gz = typeof CompressionStream === 'function';
  function nieuwePagina() { paginaId = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); seq = 0; }
  nieuwePagina();

  /* Clarity (app-embed): identify met het uniqToken (Clarity hasht dat zelf in
     de browser) en de tag frontrun_wie zodra de server `wie` gaf. clarity()
     bestaat pas als de app-embed geladen is; tot een minuut lang opnieuw. */
  function naarClarity(id) {
    var keer = 0;
    (function probeer() {
      if (typeof window.clarity === 'function') {
        try {
          window.clarity('identify', id);
          if (clarityTag) window.clarity('set', 'frontrun_wie', clarityTag);
        } catch (e) {}
        return;
      }
      if (++keer < 60) setTimeout(probeer, 1000);
    })();
  }

  function verstuur(body, laatste) {
    var tekst = JSON.stringify(body);
    // Bij het weggaan: sendBeacon (geen ingepakte variant; er is geen tijd om te wachten).
    if (laatste) {
      if (navigator.sendBeacon) navigator.sendBeacon(DOEL, tekst);
      return;
    }
    var verzoek = function (lijf, ingepakt) {
      return fetch(DOEL + (ingepakt ? '?gz=1' : ''), { method: 'POST', body: lijf, mode: 'cors',
        credentials: 'omit', headers: { 'Content-Type': 'text/plain' }, keepalive: !ingepakt && tekst.length < 60000 });
    };
    var p = gz
      ? new Response(new Blob([tekst]).stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer()
          .then(function (b) { return verzoek(b, true); }, function () { gz = false; return verzoek(tekst, false); })
      : verzoek(tekst, false);
    p.then(function (r) {
      if (!clarityTag && r && r.status === 200) {
        return r.json().then(function (j) {
          if (j && /^[0-9a-f]{6}$/.test(j.wie || '')) { clarityTag = j.wie; naarClarity(body.id); }
        });
      }
    }).catch(function () {});
  }

  function stuur(laatste) {
    if (!buffer.length) return;
    // Toestemming ingetrokken of een pad dat niet mag: niets meer sturen, en stoppen.
    if (!mag()) { buffer = []; stopOpname(); return; }
    var id = wie();
    if (!id) return;
    var events = buffer; buffer = [];
    inBatches(events, BATCH_MAX).forEach(function (b) {
      verstuur({ id: id, tz: tz, paginaId: paginaId, pad: location.pathname, seq: seq++, events: b }, laatste);
    });
  }

  function stopOpname() { if (stop) { try { stop(); } catch (e) {} stop = null; } }

  function start() {
    if (stop || laden || !mag()) return;
    laden = true;
    var s = document.createElement('script');
    // integrity: wijzigt het bestand op de CDN ooit, dan draait het niet in plaats van iets anders.
    s.src = BIB; s.async = true; s.crossOrigin = 'anonymous';
    s.integrity = 'sha384-UXg/O1bVryk2M3h7gqexGANyLz+zFnrl1KWPxii4mUPP42AwGp1LvfeGjURH/0F9';
    s.onload = function () {
      laden = false;
      if (!window.rrwebRecord || !mag()) return;
      stop = window.rrwebRecord.record({
        emit: function (e) { buffer.push(e); },
        maskAllInputs: true,
        maskTextSelector: '[data-privacy], .customer, .account, [class*="customer-"], [class*="account-"], ' +
          'predictive-search, .predictive-search, [data-predictive-search], .search-results__heading',
        blockSelector: 'iframe, form[action*="/contact"], .shopify-payment-button, shopify-payment-terms, ' +
          'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify="payment-button"], [data-privacy="blok"]',
        sampling: { mousemove: 50, scroll: 150, input: 'last', media: 800 },
        slimDOMOptions: 'all',
        recordCanvas: false,
        collectFonts: false,
        checkoutEveryNms: 60000
      }) || null;
      var id = wie();
      if (id) naarClarity(id);
    };
    s.onerror = function () { laden = false; };
    document.head.appendChild(s);
  }

  /* ZICHT (15-10-2026): het dashboard moet weten of de pagina nog in beeld is.
     Een tabblad op de achtergrond, een weggezette app of een scherm dat uit
     gaat stuurt niets meer, en was daardoor niet te onderscheiden van iemand
     die stil zit te lezen. Daarom een rrweb-custom-event 'zicht' met stand
     zichtbaar, achtergrond of weg (pagina verlaten of gesloten), in de batch
     die meteen daarna gaat. Bij weggaan vuurt de spec pagehide vóór
     visibilitychange; doet een browser het andersom, dan komt 'weg' als
     laatste aan en wint die alsnog. De server leest dit in server.mjs
     (AANWEZIG) zonder de batch te parsen: verander tag en vorm alleen samen. */
  var weg = false;
  function zicht(stand) {
    try { if (stop && window.rrwebRecord.record.addCustomEvent) window.rrwebRecord.record.addCustomEvent('zicht', { stand: stand }); } catch (e) {}
  }

  setInterval(function () { stuur(false); }, 2000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { if (!weg) zicht('achtergrond'); stuur(true); }
    else zicht('zichtbaar');
  });
  window.addEventListener('pagehide', function () { weg = true; zicht('weg'); stuur(true); });
  /* Terug uit de bfcache is een nieuwe paginaweergave: nieuw id en een
     nieuwe momentopname, anders begint het dashboard halverwege. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    weg = false;
    nieuwePagina(); buffer = [];
    if (stop && window.rrwebRecord && window.rrwebRecord.record.takeFullSnapshot) window.rrwebRecord.record.takeFullSnapshot(true);
  });
  // Iemand accepteert de banner halverwege: dan begint de opname op dat moment.
  document.addEventListener('visitorConsentCollected', function () { if (toestemming()) start(); else { buffer = []; stopOpname(); } });
  // Na load: de winkel eerst, de opname daarna.
  if (document.readyState === 'complete') setTimeout(start, 0);
  else window.addEventListener('load', function () { setTimeout(start, 0); });
})();
